import { IconButton, IconButtonProps, Typography } from "@mui/material";

import React from "react";
import BNBox from "../BNBox/BNBox";
import { useTheme } from "@mui/system";
import { sxEnsureArray } from "../../Helpers/sxMerge";
import { Link } from "react-router";

export interface BNIconButtonProps extends IconButtonProps {
  label?: string;
  href?: string;
  to?: string;
  sx?: IconButtonProps["sx"];
}

const BNIconButton: React.FC<BNIconButtonProps> = (props) => {
  const theme = useTheme();
  const { children, label, href, to, sx, ...restOfProps } = props;

  const iconButtonProps = href
    ? {
        ...restOfProps,
        href: href,
        LinkComponent: "a" as IconButtonProps["LinkComponent"],
      }
    : to
      ? {
          ...restOfProps,
          to: to,
          LinkComponent: Link,
        }
      : restOfProps;

  if (label) {
    return (
      <IconButton sx={[{ borderRadius: 0 }, ...sxEnsureArray(sx)]} {...iconButtonProps}>
        <BNBox>
          {children}
          <Typography
            component={"div"}
            variant="body1"
            sx={[
              {
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                mt: -0.5,
                maxWidth: { xs: "10rem", md: "12rem" },
                color: "tertiary.dark",
              },
              theme.applyStyles("dark", {
                color: "text.primary",
              }),
            ]}
          >
            {label}
          </Typography>
        </BNBox>
      </IconButton>
    );
  }

  return (
    <IconButton sx={sx} {...iconButtonProps}>
      {children}
    </IconButton>
  );
};
export default BNIconButton;
